export default __webpack_public_path__ + "static/media/customer-search-img.8bbf823e.svg";